import { siteInfo, testimonials } from "@/mocks/manga";

const principles = [
  {
    icon: "ri-search-eye-line",
    title: "按年代考古",
    desc: "以出生年代为线索整理怀旧漫，让每个人都能沿着自己的童年找到对应作品。",
  },
  {
    icon: "ri-bookmark-line",
    title: "逐页补档",
    desc: "对旧刊扫描件逐页去灰、裁边、修复，尽力还原老漫画本来的样子。",
  },
  {
    icon: "ri-history-line",
    title: "资料留痕",
    desc: "每部老漫画标注来源、年份与整理过程，让考古漫有据可查、真实可靠。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-xs font-semibold tracking-widest text-primary-600">ABOUT US</p>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
              我们是老漫画的寻回者与存档人
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              {siteInfo.name}由一群痴迷于怀旧漫与经典老番的爱好者共建。我们相信，那些印在旧刊、
              卷纸与单行本上的童年漫画，不该被时光悄悄抹去。于是我们四处收集旧书店里的绝版资源、
              寻访当年的老漫画家，把散落的记忆一点点补全、归档，按年代与题材整理成一座可随时回访的
              老漫画档案馆。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              无论你是想找回记不清名字的童年漫画，还是想补完当年没看完的旧坑，这里都是你的起点。
            </p>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <p className="text-xs font-semibold tracking-widest text-accent-600">用户口碑</p>
              <h3 className="mt-2 font-heading text-xl text-foreground-950">
                怀旧漫爱好者怎么说
              </h3>
              <div className="mt-5 grid grid-cols-1 gap-4">
                {testimonials.map((t) => (
                  <figure
                    key={t.id}
                    className="rounded-lg border border-background-200 bg-background-100 p-4"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm text-primary-700">
                          {t.name.slice(0, 1)}
                        </span>
                        <figcaption>
                          <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                          <p className="text-xs text-foreground-500">{t.role}</p>
                        </figcaption>
                      </div>
                      <i className="ri-double-quotes-r text-2xl text-accent-300"></i>
                    </div>
                    <blockquote className="mt-3 text-sm leading-relaxed text-foreground-600">
                      {t.text}
                    </blockquote>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}